import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../../core/services';

@Component({
  selector: 'app-confirm-email',
  standalone: false,
  templateUrl: './confirm-email.html',
  styleUrl: './confirm-email.scss',
})
export class ConfirmEmail implements OnInit {
  status: 'confirming' | 'success' | 'error' = 'confirming';
  message = '';

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('confirmation_token');

    if (!token) {
      this.status = 'error';
      this.message = 'This confirmation link is missing its token.';
      return;
    }

    this.authService.confirmEmail(token)
      .pipe(
        catchError(error => {
          this.status = 'error';
          this.message = error?.error?.error?.message
            ?? 'That confirmation link is invalid or has already been used.';
          return of(null);
        }),
      )
      .subscribe(result => {
        if (!result) return;
        this.status = 'success';
        this.message = result.message || 'Email confirmed. You can now sign in.';
      });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
